'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './smart-edit-address.component';
import dynamic from 'next/dynamic';

const DynamicEditAddressComponent: ComponentType<Props> = dynamic(
  () => import('./smart-edit-address.component')
);

export default DynamicEditAddressComponent;

export function calculateEditAddressPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 615 },
    { sinceWidth: 325, height: 615 },
    { sinceWidth: 805, height: 590 }
  ];

  return {
    heightSinceWidth
  };
}
